import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import { AuthProvider } from './contexts/AuthContext';
import { registerSW } from 'virtual:pwa-register';
import { initializePWA } from './pwa/utils/pwa.utils';
import './index.css';

// Initialize PWA functionality
initializePWA();

// Register service worker with auto-update
const updateSW = registerSW({
  onNeedRefresh() {
    if (window.confirm('New content available. Would you like to update to the latest version?')) {
      updateSW(true);
    }
  },
  onOfflineReady() {
    console.log('✅ App is ready to work offline');
  },
  immediate: true,
  onRegisteredSW(swUrl) {
    console.log('Service Worker registered:', swUrl);
  }
});

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element not found');
}

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);